import React from "react";
import {  useParams } from "react-router-dom";
import CommonRegister from "../../Shared components/CommonRegister";

const Register = () => {

    let role = useParams().role || "Trainee";;



    return (
        <CommonRegister role={role} />

    )
}

export default Register;
